import { useState } from "react";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import { FiDownload } from "react-icons/fi";
import openMenu from "../images/open.svg";
import closeMenu from "../images/close.svg";
import profile from "../_data/profile.json";
import { useCopy, useLang } from "../i18n/useCopy";

/**
 * Represents navigation links and menu toggles.
 *
 * @component
 */

const NavLinks = () => {
  // State to track whether the menu is open or closed
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const t = useCopy();
  const lang = useLang();
  const links = [
    { to: lang === "ru" ? "/ru" : "/", label: t.nav.home },
    { to: "/portfolio", label: t.nav.portfolio },
    { to: "/resume", label: t.nav.resume },
    { to: "/contact", label: t.nav.contact },
  ];

  return (
    <>
      {/* Menu toggle button */}
      <button
        className="dropdown-toggle"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label={isMenuOpen ? "Close menu" : "Open menu"}
        aria-expanded={isMenuOpen}
      >
        {isMenuOpen ? (
          <img className="closeMenu" src={closeMenu} alt="" />
        ) : (
          <img className="openMenu" src={openMenu} alt="" />
        )}
      </button>
      {/* Navigation links */}
      <nav className={`links ${isMenuOpen ? "open" : "closed"}`} aria-label="Main navigation">
        {links.map((link, i) => (
          <motion.div
            key={link.to}
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.3 + (links.length - i) * 0.08, duration: 0.5, type: "spring" }}
          >
            <NavLink to={link.to} end={link.to === "/" || link.to === "/ru"} onClick={() => setIsMenuOpen(false)}>
              {link.label}
            </NavLink>
          </motion.div>
        ))}
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.5, type: "spring" }}
        >
          <a className="navCv" href={profile.cv.pdf} download onClick={() => setIsMenuOpen(false)}>
            <FiDownload aria-hidden="true" /> CV
          </a>
        </motion.div>
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.25, duration: 0.5, type: "spring" }}
        >
          <NavLink className="langSwitch" to={t.nav.switchTo} hrefLang={t.lang === "ru" ? "en" : "ru"} title={t.nav.switchTitle} onClick={() => setIsMenuOpen(false)}>
            {t.nav.switchLabel}
          </NavLink>
        </motion.div>
      </nav>
    </>
  );
};

export default NavLinks;
